<ion-content>

  <ion-item>
    <ion-label class="overlay-message" text-wrap>{{ message }}<span *ngIf="showPercentage" style="margin-left: 2%;"> {{ percentage }}%</span></ion-label>
  </ion-item>
  <ion-progress-bar [type]="progressBarType" [value]="progress"></ion-progress-bar>

</ion-content>
